import React from "react";
import { TextField, InputAdornment, CircularProgress } from "@mui/material";

interface CustomInputProps {
  loader?: boolean;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  variant?: "filled" | "outlined" | "standard";
  size?: "medium" | "small";
  label?: string;
  fullWidth?: boolean;
  type?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  error?: boolean;
  helperText?: string;
  value?: any;
  readOnly?: boolean;
  multiline?: boolean;
  rows?: number;
  required?: boolean;
  disabled?: boolean;
  color?: "primary" | "success";
}

const CustomInput: React.FC<CustomInputProps> = ({
  name,
  onChange,
  size = "small",
  label = "Outlined",
  variant = "outlined",
  fullWidth,
  type,
  startIcon,
  endIcon,
  error,
  loader = false,
  helperText,
  value,
  readOnly,
  multiline,
  rows,
  required,
  disabled,
  color = "primary",
}) => {
  return (
    <TextField
      disabled={disabled}
      color={color}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      size={size}
      multiline={multiline}
      onChange={onChange}
      id={`custom-${name}`}
      required={required}
      label={label}
      value={value}
      name={name}
      rows={rows}
      type={type}
      variant={variant}
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : null,
        endAdornment: endIcon ? (
          <InputAdornment position="end">
            {loader ? <CircularProgress size={24} /> : endIcon}
          </InputAdornment>
        ) : null,
        readOnly,
      }}
    />
  );
};

export default CustomInput;
